
import { TableSkeleton } from "@/components/ui/skeleton";

export function TransactionTableSkeleton() {
  return (
    <div className="p-4">
      <TableSkeleton rows={10} />
    </div>
  );
}
